<div class="range-slider">
  <input class="range-slider__range" type="range" [step]="step" [value]="value" [min]="min" [max]="max" (input)="valueChanged($event.target.value)">
  <span class="range-slider__value">{{percentage}}x</span>
</div>
